import { Email, UserId } from '../../domain/user';
import { WA_SERVICE } from '../../domain/waService';
import appleApi from '../../gateways/api/appleApi';
import tracker from '../../gateways/tracker/tracker';
import i18n from '../../R/string/i18n';
import TokenStorage, {
  AccessToken,
  RefreshToken
} from '../commonModels/tokenStorage';
import { AppleAuthCode } from './../../domain/apple';
import { PromiseEither } from './../../utils/either';

export class AppleEmailAlreadyRegisteredError implements Error {
  name = 'AppleConfirmEmailAlreadyRegistered';
  message = i18n.socialLoginEmailAlreadyRegistered();
}

export class AppleRegisterError {
  name = 'AppleRegisterError';
  constructor(readonly message: string) {}
}

export interface AppleRegisterSuccess {
  sessionStatus: 'signIn' | 'signUp';
  email: Email;
  accessToken: AccessToken;
  refreshToken: RefreshToken;
  userId: UserId;
}

const registerWith =
  (tokenStorage: TokenStorage) =>
  async (
    authCode: AppleAuthCode,
    waService: WA_SERVICE
  ): PromiseEither<AppleRegisterError, AppleRegisterSuccess> => {
    const res = await appleApi.register(authCode, waService);
    res.forEach(({ accessToken, refreshToken, sessionStatus, userId }) => {
      tokenStorage.setAccessToken(accessToken);
      tokenStorage.setRefreshToken(refreshToken);

      if (sessionStatus === 'signIn') {
        tracker.resumeTracking(userId);
      } else if (sessionStatus === 'signUp') {
        tracker.startTracking(userId);
        tracker.trackSocialAccountRegistration(userId);
      }
    });
    return res;
  };

export default {
  registerWith
};
